export default __webpack_public_path__ + "static/media/invoices_selected.bc64352f.svg";